export default __webpack_public_path__ + "static/usbsolderingiron-16185209eed51d583ce7a32200ddb0ab.png";